import styled from 'styled-components';

export const SummaryContainer = styled.div`
  display: flex;
  position: relative;
  border-bottom: 2px solid #d4d4d4;
  padding-bottom: 15px;
  justify-content: space-between;
`;

export const NameWrapper = styled.div`
  /* width: 46%; */
  /* grid fix */
  width: 36%;
  display: flex;
  flex-direction: column;
`;

export const NameHead = styled.span`
  color: #022737;
  display: inline-block;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: 1.14;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-weight: ${props => props.theme.fontWeight.normal};
  @media only screen and (max-width: 991px) {
    font-size: 36px;
  }
`;

export const AccountDetail = styled.div`
  margin: 15px 0;
  color: ${props => props.theme.fontColors.textColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  & p {
    height: 5px;
    width: 5px;
    background-color: ${props => props.theme.fontColors.textColor};
    border-radius: 50%;
    display: inline-block;
    margin: -3px 7px;
    vertical-align: super;
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const AccountDetails = styled.div`
  display: flex;
  & div {
    display: flex;
    align-items: flex-start;
  }
  & div:first-child {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      width: 2px;
      height: 54px;
      background: ${props => props.theme.colors.border};
      right: ${props => (props.primary ? '16px' : '24px')};
      top: 2px;
    }
  }
  & div:last-child {
    justify-content: flex-end;
  }
  & div span:first-child {
    display: inline-block;
    color: ${props => props.theme.fontColors.textColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.grantSummary};
  }
  & div span:last-child {
    width: 160px;
    display: inline-block;
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    color: ${props => props.theme.headingColor};
    line-height: ${props => props.theme.lineHeight.h4};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    font-size: ${props => props.theme.fontSize.h4};
    padding: 0 15px;
    box-sizing: border-box;
    color: #022737;
  }
`;

export const Count = styled.p`
  display: ${props => (props.primary ? 'inline-block' : 'block')};
  margin: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  font-size: ${props => props.theme.fontSize.advisorCount};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  margin-right: ${props => (props.primary ? '10px' : 0)};
`;

export const Text = styled.span`
  margin: 0;
  vertical-align: super;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #022737;
`;

export const TextCount = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.border};
  padding-bottom: 10px;
  margin-top: ${props => (props.primary ? '10px' : '0')};
`;
